import React, { Component } from 'react';
import PropTypes from 'prop-types';
import FormGroup from "../formGroup";
/**
 * Component used to select a day.
 */
class DayPicker extends Component {
   constructor(props) {
      super(props);
      this.selectRef = React.createRef();

      this.handleChange = this.handleChange.bind(this);
   }

   /**
    * Returns the label of a day type from it's value
    * @param day day type
    */
   static dayLabel(day) {
      const dayLabel = reachMap.daysOptions.values.find((el) => {
         return (el.value === day);
      }).label;

      return (dayLabel);
   }

   /**
    * Put the focus on the dayPicker input
    */
   focus() {
      this.selectRef.current.focus();
   }

   /**
    * Handle the day picker change event
    * @param e - The event object
    */
   handleChange(e) {
      const value = e.target.value;

      if (this.props.onSelectedDay)
         this.props.onSelectedDay(value);
   }
   /**
    * renders the DayPicker component
    */
   render() {
      const selectedDay = this.props.selectedDay;
      const daysList = reachMap.daysOptions.values;

      return (
         <FormGroup
            iconName="calendar"
            labelId="day-picker-label"
            resourceKey="ReachMapRes.DayLabelText">
            <select
               id="days" name="days"
               value={selectedDay}
               onChange={this.handleChange}
               ref={this.selectRef}>
               {
                  daysList.map(day => {
                     return (
                        <option key={day.value} value={day.value}>
                           {day.label}
                        </option>
                     );
                  })
               }
            </select>
         </FormGroup>
      );
   }
}

DayPicker.propTypes = {
   /**
    * A callback called when a day is selected
    */
   onSelectedDay: PropTypes.func,
   /**
    * Current value of the picklist
    */
   selectedDay: PropTypes.string
}

export default DayPicker;
